export class depenses {
    id: number;
    clientId: string;
    busId: string;
    schoolId: string;
    type: string;
    title: string;
    receptionName: string;
    expenseDate: string;
    creationDate: string;
    modificationDate: string;
    price: number;
    volume: number;
    kilometrage: number;
    note: string;
    filePath: string;
  
    constructor() {
    }
  }


// WEBPACK FOOTER //
// ./src/app/models/depenses.ts